import { useEffect, useState } from 'react'
import { SliderArrowButtons } from './SliderArrowButtons'
import { useSwiper } from 'swiper/react'

/** Instance-local controls also work with Swiper's native CSS scrolling. */
const readNavigationState = (swiper: ReturnType<typeof useSwiper>) => ({
  available: Boolean(swiper.el && !swiper.isLocked && swiper.snapGrid.length > 1),
  beginning: swiper.isBeginning,
  end: swiper.isEnd,
})

const SliderArrows = ({ label, inset = 0 }: { label: string, inset?: number }) => {
  const swiper = useSwiper()
  const [state, setState] = useState(() => readNavigationState(swiper))

  useEffect(() => {
    const update = () => {
      const next = readNavigationState(swiper)
      setState(current => current.available === next.available
        && current.beginning === next.beginning
        && current.end === next.end ? current : next)
    }
    const events = ['afterInit', 'progress', 'resize', 'update', 'lock', 'unlock'] as const
    events.forEach(event => swiper.on(event, update))
    update()
    return () => { events.forEach(event => swiper.off(event, update)) }
  }, [swiper])

  return <SliderArrowButtons {...state} label={label} inset={inset}
    onPrevious={() => swiper.slidePrev()} onNext={() => swiper.slideNext()} />
}

export default SliderArrows
